import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import type { User } from '@/_types/models/user';

export const sendDailyNotification = async ({
  token,
}: APIRequest): APIResponsePromise =>
  await _callBackend('/advisors/send_daily_notification', 'POST', null, token);

export const updateAdvisor = async ({
  id,
  token,
  user,
}: APIRequest<{
  id: number;
  user: Partial<User>;
}>): APIResponsePromise =>
  await _callBackend(`/advisors/${id}`, 'PATCH', { ...user }, token);

export const downloadOverviewPageAsSpreadsheet = async ({
  questionnaireIds,
  token,
}: APIRequest<{
  questionnaireIds: number[];
}>): APIResponsePromise =>
  await _callBackend(
    '/advisors/download_overview_page_as_spreadsheet',
    'POST',
    { questionnaire_ids: questionnaireIds },
    token,
  );

export const sendClientLoginInfo = async ({
  userIds,
  token,
}: APIRequest<{
  userIds: Array<number>;
}>): APIResponsePromise =>
  await _callBackend(
    '/advisors/send_client_login_info',
    'POST',
    { user_ids: userIds },
    token,
  );

export const updateOOO = async ({
  userId,
  token,
  params,
}: APIRequest<{
  userId: number;
  params: {
    default_message: string;
    enabled: boolean;
    redirect_user_id: number;
  };
}>): APIResponsePromise =>
  await _callBackend(`/out_of_office/${userId}`, 'PATCH', { ...params }, token);
